import React, { useEffect, useState} from 'react';
import './styleSheets/loadingScreen.css';

const LoadingScreen = ({ onFadeOutComplete }) => {
  const [fadeClass, setFadeClass] = useState('fade-in');

  
  useEffect(() => {
    if (onFadeOutComplete) {
      const fadeTimeout = setTimeout(() => {
        setFadeClass('fade-out');
        setTimeout(() => onFadeOutComplete(), 400); 
      }, 800); 

      return () => clearTimeout(fadeTimeout);
    }
  }, [onFadeOutComplete]);

  return (
    <div className="loading-screen">
      <div className="plane-animation">
        {/* Dots for trailing effect */}
        {[...Array(20)].map((_, index) => (
          <div key={index} className={`dot dot-${index + 1}`}></div>
        ))}
        <img src="/planeLoading.png" alt="Plane" className="plane" />
        <img src="/flashLoading.png" alt="Flash" className="flash" />
        <p><strong>Loading, please wait...</strong></p>
      </div>
    </div>
  );
};

export default LoadingScreen;
